import React from 'react';
import styled from 'styled-components';

const AdContainerC = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  grid-column: span 14;
  margin: 2rem 0rem;
`;

export default AdContainerC;